import React, { Component } from "react";
import moment from "moment-timezone";
import "./Message.css";

export default class Message extends Component {
  render() {
    moment.locale("pt-BR");
    return (
      <div className="message">
        <div className={"bubble " + (this.props.own ? "own" : "")}>
          <div className={"client " + (this.props.own ? "hidden" : "")}>
            {this.props.message.participante_nome}
          </div>
          <div className="text">
            <span className="content">{this.props.message.mensagem}</span>
            <span className="time">
              {moment(this.props.message.envio, "DD/MM/YYYY HH:mm:ss")
                .tz("America/Sao_Paulo")
                .format("HH:mm")}
            </span>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/chat/Message.js